module.exports = __webpack_public_path__ + "img/GY.e10edb37.png";